export default __webpack_public_path__ + "static/media/Renata-Souza-1.3a51450b.jpg";